import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffPriceListSuppliers = () => import('./staff/crudPriceListSuppliers')
const ViewStaffPriceListSuppliersImportLog = () => import('./staff/crudImportLog')
const ViewStaffPriceListSuppliersUpdateExternal = () => import('./staff/crudUpdateExternal')

Vue.use(Router)

const router =
  [
    {
      path: '/st/costs',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'CostsStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Precios de Productos',
          }                                  
        },
        {
          path: 'price-list-suppliers',
          name: 'CostsStaffPriceListSuppliers',
          component: ViewStaffPriceListSuppliers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de precios de productos',
          }
        },      
        {
          path: 'price-list-suppliers-import-log',
          name: 'CostsStaffPriceListSuppliersImportLog',
          component: ViewStaffPriceListSuppliersImportLog,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Precios de Productos - Log de Importación',
          }                    
        },                
        {
          path: 'price-list-suppliers-update-external',
          name: 'CostsStaffPriceListSuppliersUpdateExternal',
          component: ViewStaffPriceListSuppliersUpdateExternal,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Precios de Productos - Actualización Externa',
          }          
        },                        
      ]
    },

    {
      path: '/cu/costs',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/costs',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
